import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';

function AgentStatusChart({ data }) {
  if (!data) {
    return (
      <div style={{
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        height: '100%', 
        color: 'var(--text-muted)', 
        fontSize: '14px'
      }}>
        Loading agent status...
      </div>
    );
  }

  const { summary, agents } = data;

  const chartData = [
    { name: 'Inbound', value: summary.inbound, color: '#0a72e7', agents: agents.inbound },
    { name: 'Outbound', value: summary.outbound, color: '#f59e0b', agents: agents.outbound },
    { name: 'Inactive', value: summary.inactive, color: '#e5e7eb', agents: agents.inactive }
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const item = payload[0].payload;
      const agentList = item.agents?.map(a => a.extension).join(', ') || 'None';
      return (
        <div style={{
          background: 'white', 
          border: '1px solid var(--border)',
          borderRadius: 'var(--radius-sm)', 
          boxShadow: 'var(--shadow-md)',
          padding: '10px', 
          fontSize: '13px'
        }}>
          <div style={{ fontWeight: '600', marginBottom: '4px' }}>
            {item.name}: {item.value} agents
          </div>
          <div style={{ color: 'var(--text-secondary)' }}>{agentList}</div>
        </div>
      );
    }
    return null;
  };

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      height: '100%',
      justifyContent: 'space-between'
    }}>
      {/* Top: summary counts */}
      <div style={{ 
        display: 'flex', 
        gap: '12px', 
        marginBottom: '8px',
        flexShrink: 0
      }}>
        {chartData.map(item => (
          <div key={item.name} style={{ textAlign: 'center' }}>
            <div style={{ 
              fontSize: '20px', 
              fontWeight: '700', 
              color: item.color 
            }}>
              {item.value}
            </div>
            <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>
              {item.name}
            </div>
          </div>
        ))}
      </div>

      {/* Middle: chart with constrained height */}
      <div style={{ 
        width: '100%', 
        flex: 1, 
        minHeight: 0,
        position: 'relative'
      }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie 
              data={chartData} 
              cx="50%" 
              cy="50%" 
              innerRadius={40} 
              outerRadius={65} 
              paddingAngle={4} 
              dataKey="value"
            >
              {chartData.map((entry, index) => (
                <Cell 
                  key={`cell-${index}`} 
                  fill={entry.color} 
                  stroke={entry.color === '#e5e7eb' ? '#d1d5db' : 'none'} 
                />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default AgentStatusChart;

